import { array, partial } from 'io-ts/Decoder';

import { Id as OrganizationId } from '../../../../organization/Id';
import { Id as UsageId } from '../../../../whole-house/usage/Id';

export const Request = partial({
	organizationIds: array(OrganizationId),
	usageIds: array(UsageId),
});
